<footer class="boxContainer">
  <div *ngIf="isLoading" id="loading">
    <img src="../../../assets/images/icon_gier.png" alt="Carregando...">
  </div>
  
  <div class="logo">
    <!-- <img src="assets/logo.png" alt="Logo"> -->
  </div>
  <div class="divider"></div>
  <div class="icons">
    <div class="logo-cidadeInteligente">
      <img src="assets/images/icon_gier.png" alt="Logo">
      <span class="prefeitura-demonstracao">Prefeitura <br /> Demonstração</span>
      <span class="gray-detail"></span>
    </div>
    <div class="box-footer ml-3" style="margin-top: 40px;">
      <div class="social-media">
        <div>
          <a href="https://www.instagram.com" target="_blank"><i class="cor-hover fab fa-instagram"></i></a>
          <a href="https://www.facebook.com" target="_blank"><i class="cor-hover fab fa-facebook-f"></i></a>
        </div>
        <div>
          <a href="https://www.linkedin.com" target="_blank"><i class="cor-hover fab fa-linkedin-in"></i></a>
          <a href="https://www.youtube.com" target="_blank"><i class="cor-hover fab fa-youtube"></i></a>
        </div>
      </div>
      <div class="eicon-corporation">
        © Eicon Corporation 2024
      </div>
    </div>
  </div>
  <div class="version">
    {{ versaoApp }}
  </div>
</footer>
<span class="orange-detail"></span>